import {SystemMessageAction} from '@/types/matrix';
import {TFunction} from 'i18next';
import {MatrixEvent, MsgType} from 'matrix-js-sdk';

export const getEventText = (event: MatrixEvent, t: TFunction): string => {
  const msgType = event.getContent().msgtype;
  const redacted_because = event.getEffectiveEvent().unsigned?.redacted_because;

  if (msgType === MsgType.Text) {
    return event.getContent().body || '';
  } else if (typeof msgType === 'undefined' && redacted_because) {
    return t(SystemMessageAction.Redacted);
  } else if (msgType === MsgType.Image) {
    return t('chat:image_message_text');
  } else if (msgType === MsgType.Video) {
    return t('chat:video_message_text');
  }
  return ``;
};
